import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Alert, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { useUserStore, useCartStore } from 'stores';
import { Link } from 'react-router-dom';
//api
import { createGiftCardCoupon } from 'api/invoice';
import { createGiftCard } from 'api/ecommerce';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import FeedbackStatus from 'components/userzone/FeedbackStatus';
import TitleWithLine from 'components/titleWithLine';
import { InputCustom } from 'components/input';
import ButtonCustom from 'components//userzone/buttons/ButtonCustom';
import Head from 'components/metatags_helmet/metatags';
//styles
import './giftCard.scss';

const resetData = {
  coupon: '',
  discount: '',
  email: '',
};
const GiftCard = () => {
  const [feedbackType, setFeedbackType] = useState('');
  const [showCard, setShowCard] = useState(false);
  const [msg, setMsg] = useState('');
  const { hasGiftCard, setGiftCard, removeGiftCard } = useCartStore();
  const { isLogged } = useUserStore();
  const { t } = useTranslation(['card', 'backoffice', 'header']);
  const title = t('tarjetaRegalo', { ns: 'header' });
  const [loading, setLoading] = useState(false);
  const { assignedLibrary } = useAssignedLibrary();

  const {
    reset,
    formState: { errors },
    control,
    handleSubmit,
  } = useForm();

  const handleCreateGiftCard = async (values) => {
    if (isLogged) {
      setMsg('');
      setLoading(true);
      try {
        const payload = {
          title: values.coupon,
          discount_amount: parseFloat(values.discount),
          email: values.email,
        };
        const { status, data } = await createGiftCardCoupon(payload);
        if (status === 200) {
          const { status: statusGiftCard, data: dataGiftCard } = await createGiftCard({ id: data.id });
          if (statusGiftCard === 200) {
            reset(resetData);
            setFeedbackType('success');
            setGiftCard(payload);
            // dispatch(setGiftCard(data.item?.gift_card_coupon)); //! NO ELIMINAR - SE USARA!
          } else if (statusGiftCard === 400 || statusGiftCard === 404) {
            setFeedbackType('error');
            setShowCard(true);
            setMsg(dataGiftCard || t("somethingwrong", { ns: 'card' }))
          } else {
            setFeedbackType('error');
            setShowCard(true);
            setMsg(t("somethingwrong"))
          }
        } else {
          setFeedbackType('error');
          setShowCard(true);
          setMsg(data)
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      removeGiftCard();
    }
    setLoading(false);
  };

  const string = 'aquí';

  return (
    <div className="containerGiftCard">
      <Head title={title} />
      <TitleWithLine text={t('comprarTarjetaRegalo')} />
      {isLogged ? (
        <>
          <p className="description">
            <b>{t('detalleText')}</b>
          </p>
          <div className="giftDiv">
            <Form onSubmit={handleSubmit(handleCreateGiftCard)}>
              <div className="giftDiv d-flex">
                <Row className="d-flex flex-column inputForm">
                  <Col md={6} lg={6} xs={12} className="containerInput">
                    <Controller
                      control={control}
                      name="coupon"
                      rules={{
                        required: {
                          value: true,
                          message: t('camporequerido', { ns: 'backoffice' }),
                        },
                      }}
                      render={({ field: { onChange, value } }) => (
                        <InputCustom
                          label={`${t('nombreTarjetaRegalo')}:`}
                          type="text"
                          value={value}
                          onChange={(event) => onChange(event)}
                          placeholder={t('escribeNombreTarjetaRegalo')}
                          className="styleInput"
                          disabled={hasGiftCard}
                        />
                      )}
                    />
                    {errors?.coupon && <small className="text-danger ">{errors.coupon.message}</small>}
                  </Col>
                  <Col md={6} lg={6} xs={12} className="containerInput mt-3">
                    <Controller
                      control={control}
                      name="discount"
                      rules={{
                        required: {
                          value: true,
                          message: t('camporequerido', { ns: 'backoffice' }),
                        },
                        pattern: {
                          value: /^[0-9.]+$/,
                          message: t('solonumeros', { ns: 'backoffice' }),
                        },
                      }}
                      render={({ field: { onChange, value } }) => (
                        <InputCustom
                          label={`${t('amount', { ns: 'backoffice' })}:`}
                          type="text"
                          value={value}
                          onChange={(event) => onChange(event)}
                          placeholder={t('enterTheAmount')}
                          className="styleInput"
                          disabled={hasGiftCard}
                        />
                      )}
                    />
                    {errors?.discount && <small className="text-danger ">{errors.discount.message}</small>}
                  </Col>
                  <Col md={6} lg={6} xs={12} className="containerInput mt-3">
                    <Controller
                      control={control}
                      name="email"
                      rules={{
                        required: {
                          value: true,
                          message: t('camporequerido', { ns: 'backoffice' }),
                        },
                        pattern: {
                          value: /^\S+@\S+$/i,
                          message: t('emailinvalid', { ns: 'backoffice' }),
                        },
                      }}
                      render={({ field: { onChange, value } }) => (
                        <InputCustom
                          label={`${t('orderTrans.email', { ns: 'backoffice' })}:`}
                          type="email"
                          value={value}
                          onChange={(event) => onChange(event)}
                          placeholder={t('writeEmail')}
                          className="styleInput"
                          disabled={hasGiftCard}
                        />
                      )}
                    />
                    {errors?.email && <small className="text-danger ">{errors.email.message}</small>}
                  </Col>
                </Row>
                {feedbackType && (typeof msg === "string" && msg !== '') &&
                  <FeedbackStatus feedbackType={feedbackType} isVisible={showCard} msgObject={msg} />
                }
                {feedbackType && typeof msg === 'object' && Object.entries(msg).map(([key, value]) => <FeedbackStatus feedbackType={feedbackType} isVisible={showCard} msgObject={{ [key]: value[0] }} />)}
                <div className="my-3">
                  {hasGiftCard ? (
                    <>
                      <FeedbackStatus feedbackType="success" isVisible={true} msgObject={t('addgiftcardalready')} />
                      <ButtonCustom color="secondary">
                        <Link to={`/${assignedLibrary}/carrito`} className="text-button openSans">
                          {t('procederCompra')}
                        </Link>
                      </ButtonCustom>
                    </>
                  ) : (
                    <ButtonCustom color="secondary" className="width-btn-save" loading={loading}>
                      {loading ?
                        <Spinner /> : <input
                          className="text-button openSans"
                          type="submit"
                          value={t('crearTarjeta')}
                        />
                      }
                    </ButtonCustom>
                  )}
                </div>
              </div>
            </Form>
          </div>
        </>
      ) : (
        <>
          <Row className="notice-logout">
            <Col>
              <Alert className="flex-column" show={true} variant="info">
                <Alert.Heading>{t('informacionIncompleta')}</Alert.Heading>
                <p>{t('loguearteOCrearCuenta')}</p>
                <hr className="w-100" />
                <div className="d-flex w-100">
                  <p>{t('iniciaSesionORegistrate')}</p>
                  <Link to={`/${assignedLibrary}/inicio-sesion`} className="ml-2">
                    {string.toUpperCase()}
                  </Link>
                </div>
              </Alert>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default GiftCard;
